import React, { Component } from 'react';
import PropTypes from 'prop-types';
import unionClassNames from 'union-class-names';
import EditorUtils from 'draft-js-plugins-utils';
import {Form, InputGroup, InputGroupAddon, PopoverBody, PopoverHeader, UncontrolledPopover} from "reactstrap";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { EditorState, RichUtils } from 'draft-js';

export default class LinkAdd extends Component {

    state = {
        url: '',
        open: false,
    };

    promptForLink = (event) => {
        event.preventDefault();

        if (this.state.open) {
            this.setState({ open: false, url: '' });
            return;
        }

        // e.stopPropagation();
        const {editorState} = this.props;
        const selection = editorState.getSelection();
        const contentState = editorState.getCurrentContent();



        if (!selection.isCollapsed()) {
            const contentState = editorState.getCurrentContent();
            const startKey = editorState.getSelection().getStartKey();
            const startOffset = editorState.getSelection().getStartOffset();
            const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
            const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

            let url = '';
            if (linkKey) {
                const linkInstance = contentState.getEntity(linkKey);
                url = linkInstance.getData().url;
            }

            this.setState({url: url, open: true });
            setTimeout(() => { this.refs.url.focus(); });
        }
    };

    removeLink = () => {
        const {editorState, onChange} = this.props;
        const selection = editorState.getSelection();

        if (!selection.isCollapsed()) {
            onChange(RichUtils.toggleLink(editorState, selection, null));
        }

        this.setState({ open: false });
    };

    confirmLink = () => {
        const {editorState, onChange} = this.props;
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'LINK',
            'MUTABLE',
            {url: this.state.url}
        );
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
        onChange(RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey));
        this.setState({ url: '', open: false });
    };

    toggle = () => {
        const {editorState} = this.props;
        const selection = editorState.getSelection();
        if (!selection.isCollapsed()) {
            this.setState({
                editorState: RichUtils.toggleLink(editorState, selection, null),
            });

            return;
        }

        this.setState({ open: !this.state.open });
    };

    changeUrl = (evt) => {
        this.setState({ ...this.state, url: evt.target.value });
    };

    onMouseDown = (event) => {
        event.preventDefault();
    };

    render() {
        const { editorState } = this.props;
        const entity = EditorUtils.getCurrentEntity(editorState);
        let active = entity && entity['type'] === 'LINK';

        return (
            <span className={this.props.className} onMouseDown={this.onMouseDown}>
                <span className={''} onClick={this.promptForLink} id="addLinkPopover"><FontAwesomeIcon icon={['far', 'link']}/></span>
                <UncontrolledPopover placement="bottom" target='addLinkPopover' isOpen={this.state.open}>
                    <PopoverHeader>Add link</PopoverHeader>
                    <PopoverBody>
                        <Form inline={true}>
                            <InputGroup>
                                <input type="text" ref="url" placeholder="Paste link url" className={'form-control'} onClick={() => { this.refs.url.focus(); }} onChange={this.changeUrl} value={this.state.url}/>
                                <InputGroupAddon addonType="append">
                                    <button className={'btn btn-sm btn-primary'} type="button" onClick={this.confirmLink}><FontAwesomeIcon icon={['far', 'link']}/></button>
                                    { active && <button type='button' className={'btn btn-sm btn-primary'} onClick={this.removeLink}><FontAwesomeIcon icon={['far', 'unlink']}/></button> }
                                </InputGroupAddon>

                            </InputGroup>
                        </Form>
                    </PopoverBody>
                </UncontrolledPopover>
            </span>
        );
    }
}